/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Main App component
Author: Deimos Space UK

Version: 1.0
*/
import React from 'react';
import './index.css';
import GlobalStyles from './GlobalStyles'; // Asegúrate de importar tu componente de estilos globales

import App from './App';

import { createRoot } from 'react-dom/client'
import '../src/utils/i18n/i18n';

createRoot(
  document.getElementById('root')
).render(
  <>
    <GlobalStyles />
    <App />
  </>
)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

